/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTileResultsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {GetTileResultsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const getTileResults = (request:GetTileResultsRequest, options?: CashRequestOptions) => post<GetTileResultsRequest, GetTileResultsResponse>("/2.0/cash/get-tile-results", request, {...options, rejectOnError: true })